import type {
  ReactElement,
  ReactNode,
} from 'react';
import styled from 'styled-components';

import { Breadcrumbs } from '../Breadcrumbs';
import type {
  BreadcrumbType,
} from '../Breadcrumbs';
import { PageTitle } from '../PageTitle';

export const StyledWrapper = styled.div<{
  $hasBreadcrumbs: boolean;
}>(({
  $hasBreadcrumbs,

  theme: {
    indents,
  },
}) => ({
  paddingTop: $hasBreadcrumbs ? 0 : indents.INDENT_7,
  paddingBottom: indents.INDENT_8,
}));

export const StyledParentTitle = styled.div<{
  $hasBreadcrumbs: boolean;
}>(({
  $hasBreadcrumbs,

  theme: {
    indents,
  },
}) => ({
  marginTop: $hasBreadcrumbs ? indents.INDENT_7 : 0,
}));

export const StyledHeaderBlockWrapper = styled.div(({
  theme: {
    indents,
  },
}) => ({
  marginBottom: indents.INDENT_6,
}));

export type ListLayoutProps = {
  /**
   * Массив объектов хлебных крошек
   */
  breadcrumbs?: BreadcrumbType[];
  /**
   * Заголовок страницы
   */
  title: ReactNode;
  /**
   * Блок, выводящийся между заголовком страницы и содержимым
   */
  headerBlock?: ReactNode;
  /**
   * Блок действий (кнопки и т.п.)
   */
  actionsBlock?: ReactNode;
  /**
   * Содержимое страницы
   */
  children?: ReactNode;
};

export function ListLayout({
  breadcrumbs = undefined,
  title,
  headerBlock = undefined,
  actionsBlock = undefined,
  children = undefined,
}: ListLayoutProps): ReactElement {
  const hasBreadcrumbs = breadcrumbs
    ? breadcrumbs.length > 0
    : false;

  return (
    <StyledWrapper
      $hasBreadcrumbs={hasBreadcrumbs}
    >
      {
        breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs
            breadcrumbs={breadcrumbs}
          />
        )
      }

      <StyledParentTitle
        $hasBreadcrumbs={hasBreadcrumbs}
      >
        <PageTitle
          actionsBlock={actionsBlock}
        >
          {title}
        </PageTitle>
      </StyledParentTitle>

      {
        headerBlock && (
          <StyledHeaderBlockWrapper>
            {headerBlock}
          </StyledHeaderBlockWrapper>
        )
      }

      {children}
    </StyledWrapper>
  );
}
